
import { Filtro } from '../_models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from './alert.service';
import {environment} from '../../environments/environment';


@Injectable({
    providedIn: 'root'
})

export class FiltroPesquisaService {

    ObterFiltros(): Observable<any> {
        return this.http.get<Filtro[]>(`${environment.apiUrl}/api/filtro`);
    }

    ObterFiltroItens(idFiltro: number): Observable<any> {
        return this.http.get<Filtro[]>(`${environment.apiUrl}/api/filtro/${idFiltro}/itens`);
    }

    CriarFiltro(filtro: Filtro): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/filtro`;
        return this.http.post<any>(apiURL, filtro);
    }

    AtualizarFiltro(filtro: Filtro): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/filtro`;
        return this.http.put<any>(apiURL, filtro);
    }

    ExcluirFiltro(filtro: Filtro): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/filtro`;
        
        const opcoes = {
            observe: 'body' as const,
            body: filtro,  
          };

        return this.http.delete<any>(apiURL, opcoes);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }
}
